import QuotationResult from "../../domain/Transaction/QuotationResult";
import WsService from "../WsService";
import UserSessionService from "../UserSessionService";

const ENDPOINT_BASE = "/transactions/beneficiary-quotation";

export default class BeneficiaryQuotationService {

    static requestQuotation(beneficiaryQuotationRequest) {

        let transactionHeaders = UserSessionService.retrieveTransactingHeaders();

        let headers = {
            ...transactionHeaders
        };

        return WsService.postWithHeaders(ENDPOINT_BASE, beneficiaryQuotationRequest, 201, headers).then(
            response => {
                return new QuotationResult(response);
            },
            response => {
                return response;
            }
        )
    }
}